'use strict';

/*global services*/

(function ($) {
  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_charCounter.defaults, options);

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('char-counter-init')) {
          return;
        }

        var $counter = $('<div>', {
          class: 'char-counter-preview'
        });

        var charCounterText = services.get('translator').trans('char_counter.text');
        charCounterText = charCounterText.replace('%s1', '<span class="res-chars">0</span>');
        charCounterText = charCounterText.replace('%s2', '<span class="max-chars">' + $this.data('max_char') + '</span>');

        $counter.html(charCounterText);
        $counter.insertAfter($this);
        $this.addClass('char-counter-init');

        $this.on('keyup', function (e) {
          methods.reCount.apply(_this, e);
        });

      });
    },

    reCount: function () {
      //var _this = this;
      var $this = $(this);

      var value = $this.val();

      if (value.length > $this.data('max_char')) {
        value = value.substring(0, $this.data('max_char'));
        $this.val(value);
      }

      var $counter = $this.parent().find('.char-counter-preview');
      $counter.find('.res-chars').text(value.length);
    }
  };

  $.fn.k2_charCounter = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_charCounter');
    }

  };

  $.fn.k2_charCounter.defaults = {};

})(jQuery);
